{
  "item": {
    "zero": "No items",
    "plural": "{{count}} items",
    "single": "1 item"
  },
  "idea": {
    "zero": "No {{feedback}}",
    "plural": "{{count}} {{feedbacks}}",
    "Plural": "{{count}} {{Feedbacks}}",
    "single": "1 {{feedback}}",
    "Single": "{{count}} {{Feedback}}",
    "feedback": "{{feedback}}",
    "Feedback": "{{Feedback}}",
    "feedbacks": "{{feedbacks}}",
    "Feedbacks": "{{Feedbacks}}"
  },
  "company": {
    "zero": "No {{companies}}",
    "plural": "{{count}} {{companies}}",
    "Plural": "{{count}} {{Companies}}",
    "single": "1 {{company}}",
    "Single": "1 {{Company}}",
    "company": "{{company}}",
    "Company": "{{Company}}",
    "companies": "{{companies}}",
    "Companies": "{{Companies}}",
    "select": "Select {{company}}",
    "specificSingle": "Specific {{companies}}...",
    "specificPlural": "Specific {{companies}} ({{count}})",
    "yesSpecificSingle": "Yes, specific {{companies}}...",
    "yesSpecificPlural": "Yes, specific {{companies}} ({{count}})",
    "CompanyCustomFields": "{{Company}} Custom Fields",
    "CompanyFields": "{{Company}} Fields",
    "CompanyDetails": "{{Company}} Details"
  },
  "category": {
    "zero": "No categories",
    "plural": "{{count}} categories",
    "Plural": "{{count}} Categories",
    "single": "1 category",
    "Single": "1 Category",
    "category": "category",
    "Category": "Category",
    "categories": "categories",
    "Categories": "Categories"
  },
  "auth": {
    "text1": "Here’s the place for you to browse users {{feedback}} about your products and suggest your own {{feedback}}",
    "text2": "Thank you. Your account is now ready for use.\nPlease login to create the fantastic {{feedback}}."
  },
  "activity": {
    "idea": "{{feedback}}",
    "ideas": "{{feedback}}",
    "category": "category",
    "categories": "categories"
  },
  "userRoles": {
    "Anonymous": {
      "name": "Anonymous",
      "desc": "Anonymous user."
    },
    "CompanyUser": {
      "name": "User",
      "desc": "Authenticated user."
    },
    "Reviewer": {
      "name": "Reviewer",
      "desc": "Can view, comment on, vote and track any {{feedback}}."
    },
    "Contributor": {
      "name": "Contributor",
      "desc": "Has Reviewer permissions + can create and edit his own {{feedback}}."
    },
    "Editor": {
      "name": "Editor",
      "desc": "Has Contributor permissions + can edit any category or {{feedback}} and its internal status, labels and other metadata."
    },
    "AccountOwner": {
      "name": "Account owner",
      "desc": "Has Editor permissions + can manage {{companies}} which he was assigned to."
    },
    "ProcessOwner": {
      "name": "Process owner",
      "desc": "Has Account Owner permissions + can manage all {{companies}}, edit the details of any {{feedback}} on behalf of other users. Can change Workflow & Statuses. Can promote and link {{feedback}} to Craft.io items."
    },
    "Admin": {
      "name": "Admin",
      "desc": "Has Process Owner permissions + setup integrations + can change General Settings and add new Team members, and can edit {{Feedback}} fields."
    },
    "PortalOwner": {
      "name": "Portal owner",
      "desc": "Has full access."
    }
  },
  "common": {
    "text1": "Delete {{feedback}}",
    "text2": "Add {{feedback}}",
    "text3": "Edit {{feedback}}",
    "text4": "0 {{Feedback}} found",
    "text5": "Please title your {{feedback}} before submission",
    "text6": "What’s your {{feedback}} about?",
    "text8": "Track {{feedback}}",
    "text9": "All {{feedbacks}}",
    "text10": "My {{feedbacks}}",
    "text11": "Tracked {{feedbacks}}",
    "text12": "Add new category",
    "text13": "Please title your category before submission",
    "text14": "Create categories",
    "text15": "Please choose category before submission",
    "text16": "Title your category",
    "text17": "Change category",
    "text18": "Add category",
    "text19": "Search {{Feedbacks}}",
    "text20": "categories",
    "text21": "category",
    "text22": "Edit {{feedback}}",
    "text23": "Back",
    "text24": "Category privacy settings...",
    "text25": "Category privacy settings",
    "text26": "Who can see this category in categories list and add {{feedback}}?",
    "text27": "Can different {{companies}} view, comment and like each other’s {{feedback}} in this category?",
    "text28": "Edit category",
    "text29": "Delete category",
    "text31": "This category contains {{count}} {{feedback}} items. Select what should be done with these items:",
    "text31One": "This category contains 1 {{feedback}} item. Select what should be done with this item:",
    "text32": "Move {{feedback}} items to",
    "text34": "Delete all {{feedback}} items",
    "text35": "Are you sure you want to delete this category?",
    "text36": "Are you sure you want to delete this {{feedback}}?",
    "text37": "All categories",
    "text38": "Add {{feedback}} to this category",
    "text39": "Search categories",
    "text40": "See my {{feedback}}",
    "text41": "Add another {{feedback}}",
    "text44": "0 categories found",
    "text45": "Number of viewable {{feedbacks}} will vary based on your access permissions",
    "text46": "See in {{feedback}}",
    "text47": "Stop tracking {{feedback}}",
    "text48": "Archive {{feedback}}",
    "text49": "Unarchive {{feedback}}",
    "text50": "Archive",
    "text50u": "Unarchive",
    "text51": "{{Feedback}} description: more details help us build better products for you to use!",
    "text52": "Archived {{feedbacks}}",
    "text54": "All {{feedbacks}} will be deleted",
    "text55": "All {{feedbacks}} will be archived",
    "text56": "Delete {{feedback}} items",
    "text57": "Are you sure you want to delete {{feedback}} items?",
    "text58": "All {{feedbacks}} will be unarchived",
    "text59": "Archive {{feedback}} items",
    "text60": "Are you sure you want to archive {{feedback}} items?",
    "text61": "Unarchive {{feedback}} items",
    "text62": "Are you sure you want to unarchive {{feedback}} items?",
    "text63": "View {{feedback}} items",
    "text64": "Import {{feedbacks}}",
    "text65": "Hidden category",
    "text66": "{{Feedbacks}} Table",
    "text67": "{{Feedbacks}} Cards",
    "text68": "Copy {{feedback}} link",
    "delete": "Delete",
    "deletedFeedback": "{{Feedback}} was deleted",
    "ftitle": "{{Feedback}} title"
  },
  "portal": {
    "text1": "This category doesn’t include any {{feedback}} yet.",
    "text2": "Be the first to post {{feedback}} about",
    "text3": "Add {{feedback}} to category",
    "text4": "doesn’t contain any {{feedback}} yet. Be the first to post {{feedback}} by letting us know how we should do better.",
    "text5": "You haven’t posted any {{feedback}} yet.",
    "text6": "Post {{feedback}} on how to improve",
    "text7": "You haven’t tracked any {{feedback}} yet.",
    "text8": "To track {{feedback}} click on",
    "text9": "track {{feedback}}",
    "text10": "near item's 3 dots menu.",
    "text11": "You haven’t archived any {{feedback}} yet.",
    "text12": "To archive {{feedback}} click on",
    "text13": "archive {{feedback}}",
    "text14": "near item's 3 dots menu."
  },
  "settings": {
    "text1": "Manage the {{companies}} that have access to your portal. {{Companies}} can view and comment on each other’s {{feedback}}.",
    "text2": "Anyone with the link can post {{feedback}}, view and comment on others {{feedback}}. To post and comment the user must sign in to the portal.",
    "text3": "Only pre-defined users can access the portal, post {{feedback}}, view and comment on others {{feedback}}. Define users in {{Company}} List page.",
    "text4": "Allow users from different {{companies}} to view and comment on each other’s {{feedback}}",
    "text5": "Use Feedback Portal to collect and manage {{feedbacks}} from your end users or internal employees.",
    "text6": "{{Feedback}} importance",
    "text7": "{{Feedback}} importance can be specified when adding a new {{feedback}}.",
    "text8": "{{Feedback}} status",
    "text9": "{{Feedback}} status is visible to all portal team members and users; use this status to communicate the progress externally.",
    "text10": "Manage {{Feedback}} Lifecycle",
    "text11": "View, add and edit their own {{feedbacks}} and categories, participate in chat / voting.",
    "text12": "Has Contributor rights + can edit any {{feedback}}, category and {{feedback}} workflow status, labels and metadata.",
    "text13": "Has Editor rights + can add and edit {{companies}} and {{company}} data. This role is only for the restricted portals.",
    "text14": "Has Account Owner rights + Edit any {{feedback}} information as if they were the {{feedback}} creator and on behalf of a {{company}}.",
    "text15": "Has Process Owner rights + Can change portal settings and add new portal users.",
    "text16": "Default for new {{feedback}}",
    "text17": "{{Feedback}} internal status",
    "text18": "Feedback portal settings",
    "text19": "Welcome to your feedback portal!",
    "text20": "{{Feedback}} internal status is visible only for {{feedback}} team members and is hidden from the rest of the users; use this status for internal purposes.",
    "text21": "Labels help you tag, locate and organize {{feedback}} items easily.",
    "text22": "Label is connected to {{count}} {{feedback}} items, label will be removed from items.",
    "text23": "Are you sure you like to delete this label?",
    "text24": "Import your existing {{feedbacks}} directly into your Craft.io Feedback Portal.",
    "text25": "Import {{feedbacks}} from a CSV file.",
    "text26": "Connect your feedback portal to various apps via Zapier.",
    "text27": "Sync your {{companies}} business information from Salesforce into Craft.io Portal",
    "text28": "Send {{feedback}} related emails directly to your feedback portal",
    "text29": "Push messages containing {{feedback}} into Craft.io Portal.",
    "text30": "You can change the field in the {{feedback}} form to ensure the {{feedbacks}} you receive answers your questions.",
    "text31": "Create {{feedback}} forms to gather {{feedbacks}} from different categories with multiple category connections.",
    "msteams": "Push messages containing {{feedback}} into your feedback portal",
    "text32": "The {{Companies}} page is enabled for Restricted Access privacy",
    "text33": "The {{Company}} Users page is enabled for Restricted Access privacy",
    "text34": "List of the workspaces that your clients will be able to give their {{feedbacks}} on.",
    "text35": "These are the workspaces you will be able to connect your {{feedbacks}} to features or items to.",
    "text36": "Customize your {{company}} records with flexible fields to enrich your data, enabling improved segmentation and data-driven idea prioritization",
    "text37": "There are no {{ company }} custom fields.",
    "termTooltip1": "Items submitted to the Portal (e.g., Feedback, Ideas, Demands)",
    "termTooltip2": "The main entity associated with the feedback (e.g., Customer, Account, Org, Division)",

    "moveToCompany": "Move to {{Company}}",
    "companyUsers": "{{Company}} Users",
    "companyAdmins": "{{Company}} Admins",
    "manageCompanyUsers": "View and manage the list of {{company}} users.",
    "manageCompanyAdmins": "Manage {{company}} Account owners",
    "forms": {
      "formHeader": "Form",
      "defaultFormTooltip": "Unassociated categories will be linked to the Default Form",
      "required": "A required field must be filled in as part of the {{feedback}} submission",
      "fieldTooltip": "Editing this field can be done from the '{{Feedback}} Fields' settings page.",
      "defaultFormCategories": "The default form is associated with all categories that\ndo not have any form associated with them.",
      "emptyCategories": "No available categories"
    },
    "companies": {
      "globalAccessTooltip": "Enable to grant all {{company}} users access to the feedback portal, disable for no access.",
      "creationSourceTooltip": "How this {{company}} record was created.",
      "hostAppSourceTooltip": "Created automatically when someone submitted {{feedback}} from your own product.",
      "individualCompanyNote": "This {{company}} is managed by Craft and cannot be deleted or renamed. Move its users to another {{company}} instead.",
      "advancedSettings": {
        "title": "{{Company}} Advanced Settings",
        "toggleTitle": "Linked workspace access permission",
        "toggleTooltip": "Toggle off: Admin linked the portal to a new workspace without granting portal access permission to this {{company}} users. Toggle on to grant access permission."
      },
      "addCompany": "Add {{Company}}",
      "emtyCompaniesTable": "There are no {{companies}} in your list",
      "invite": "Invite contact people on behalf of the {{companies}}",
      "addNewCompany": "Add New {{Company}}",
      "editCompany": "Edit {{Company}}",
      "deleteCompany": "Delete {{Company}}",
      "deleteCompanies": "Delete {{Companies}}",
      "companyName": "{{Company}} Name",
      "typeCompName": "Type {{Company}} Name",
      "cmpNameReq": "You must enter a {{company}} name.",
      "cmpInfo": "{{Company}} Information",
      "cmpSize": "{{Company}} Size",
      "create": "Create {{Company}}",
      "cmpWS": " {{Company}} requires at-least one workspace",
      "cmpReach": "Set workspaces the {{company}} can reach",
      "inviteUsers": "Invite the {{company}} contacts to the portal.",
      "deleteCmpQuestionSingle": "This {{company}} has users and {{feedback}} items associated to it.",
      "deleteCmpQuestionPlural": "These {{companies}} have users and {{feedback}} items associated to it.",
      "deleteCmpQuestion2": "Select what should be done with the users and {{feedback}} items:",
      "deleteCmpOpt1": "Move {{company}} users and {{feedback}} items to",
      "deleteCmpOpt2": "Delete {{company}} users ({{feedback}} items remain unchanged)",
      "moveToCompanyNote": "Please note that some {{Feedback}} Items may not be accessible to this user, according to the Categories Privacy Settings. These items will still be accessible to {{name}} users."
    },
    "connectedWorkspace": {
      "title": "Connected Workspace",
      "titleTooltip": "A connected workspace is the target workspace where {{feedback}} items can be connected or promoted into working items like epics and features.",
      "buttonText": "Change workspace",
      "noWorkspaceError": "The feedback portal is inaccessible until it's connected to a workspace"
    },
    "changeWorkspaceDialog": {
      "title": "Change Workspace",
      "contentHeader": "Are you sure you want to change the workspace to ",
      "contentBody": "Please note:",
      "contentBodyListItem1": "Existing {{feedback}} items and categories will not be available in the feedback portal and in the workspace unless reconnecting the feedback portal to the previous workspace.",
      "contentBodyListItem2": "{{Company}} users must be granted access to the workspace to submit and view {{feedback}}.",
      "closeButton": "Cancel",
      "acceptButton": "Change Workspace"
    },
    "statuses": {
      "subtitle": "Customize {{feedback}} statuses and importance to suit your specific workflow setup."
    },
    "categories": {
      "disableTootlip": "Categories with privacy restrictions cannot be set as default",
      "defaultFormTooltip": "Default category for new {{feedback}} submissions",
      "widgetsHeader": "Widgets",
      "deleteWidgetsOffering": "Widgets offering this category:",
      "deleteWidgetsNote": "They will no longer offer it. A widget left with no categories is switched off until you add one."
    },
    "widget": {
      "title": "{{Feedback}} Widgets",
      "subtitle": "Let people give {{feedback}} directly from your own website or product, without signing up to the portal. Define one or more widgets below, then embed them by pasting their snippet into your pages.",
      "brand": {
        "title": "Brand",
        "subtitle": "Match your own website, so the widget reads as part of it rather than a third-party tool bolted on. Applies to every widget on this portal.",
        "primaryColor": "Primary color",
        "primaryColorHelp": "Used for the submit button and the category control.",
        "saveFailed": "Sorry, the color could not be saved. Try again.",
        "failedTitle": "Could not load the brand settings",
        "failedText": "Reload the page to try again."
      },
      "widgets": {
        "title": "Widgets",
        "subtitle": "One widget for each place you collect {{feedback}}. Each one opens the form for the categories you choose, so people are asked only what is relevant to where they are.",
        "nameHeader": "Widget",
        "categoriesHeader": "Categories",
        "statusHeader": "Status",
        "statusActive": "Active",
        "statusInactive": "Inactive",
        "noCategories": "No categories",
        "emptyTitle": "No widgets yet",
        "emptyText": "Once a widget is set up for this portal, it appears here with the categories it offers.",
        "add": "Add widget",
        "failedTitle": "Could not load the widgets",
        "failedText": "Reload the page to try again.",
        "preview": "Preview"
      },
      "preview": {
        "noCategoriesTitle": "Nothing to preview",
        "noCategoriesText": "This widget offers no categories, so it has no form to show. Add a category to it first.",
        "unavailableTitle": "Preview unavailable",
        "unavailableText": "The preview could not be loaded. Check your connection and try again."
      },
      "install": {
        "title": "Installation",
        "subtitle": "Paste the script once, anywhere in your product. Then add a button for each widget, marked with that widget's ID. Changing a widget afterwards, or adding another one, needs no further code.",
        "tokenNote": "The token URL points at your own server, not at Craft.io. That endpoint signs the token with the secret key from Authentication above.",
        "helpNote": "For detailed setup instructions and examples, visit our",
        "helpLink": "Help Center",
        "scriptLabel": "Script tag",
        "emptyTitle": "No button markup yet",
        "emptyText": "Add a widget above and its button markup appears here."
      },
      "details": {
        "addTitle": "Add Widget",
        "editTitle": "Edit Widget",
        "internalName": "Internal name",
        "internalNameHelp": "Used only in these settings, to tell your widgets apart.",
        "internalNameRequired": "You must enter an internal name.",
        "widgetTitle": "Title",
        "activeTitle": "Widget status",
        "importanceTitle": "Importance field",
        "widgetTitleHelp": "The heading people see at the top of the form.",
        "widgetTitleRequired": "You must enter a title.",
        "categories": "Categories",
        "categoriesHelp": "Which categories people can choose from. Each category has its own form, so this also decides which fields they fill in. With one category there is nothing to choose, and the form opens straight away.",
        "categoriesRequired": "Choose at least one category. A widget with none cannot show a form.",
        "showImportance": "Show importance field",
        "showImportanceHelp": "If enabled, the form shows an importance field and people set it themselves. If disabled, the field is hidden and all {{feedback}} from this widget gets the value you choose.",
        "defaultImportance": "New {{feedback}} gets",
        "active": "Active",
        "activeHelp": "Turn off to stop the widget appearing, without deleting it.",
        "widgetId": "Widget ID",
        "widgetIdHelp": "Used in your button markup. It does not change when you rename the widget.",
        "delete": "Delete widget",
        "cancel": "Cancel",
        "save": "Save",
        "create": "Create widget"
      },
      "auth": {
        "title": "Authentication",
        "subtitle": "The widget submits on behalf of people already signed in to your product. Your server signs a token for whoever is signed in, using the secret below, and Craft.io checks that signature so it knows the identity is genuine.",
        "keyLabel": "Secret key",
        "keyHelp": "Craft.io keeps a copy. Your server keeps the other. Nothing else ever sees it.",
        "generateHelp": "Generating the key also lets this portal accept submitter identities managed by your own system, creating portal users and {{companies}} from them.",
        "generate": "Generate key",
        "rotate": "Rotate",
        "confirmTitle": "Rotate the secret key?",
        "confirmText": "A new key is generated and shown once. The current key keeps working for {{days}} days, so your server has to be running the new one before then or submissions stop.",
        "confirmRotate": "Rotate key",
        "cancel": "Cancel",
        "revealTitle": "Copy this now. It will not be shown again.",
        "copy": "Copy",
        "done": "Done",
        "neverInFrontEndLead": "Never put the secret key in front-end code.",
        "neverInFrontEnd": "Anyone who has it can submit {{feedback}} as any of your users. It belongs on your server, which is why the token comes from your endpoint rather than from the browser.",
        "saveFailed": "Sorry, something went wrong and no key was created. Try again.",
        "failedTitle": "Could not load the key",
        "failedText": "Reload the page to try again."
      }
    }
  },
  "promote": {
    "menu": {
      "epic": "Promote to {{epic}}",
      "story": "Promote to {{story}}"
    },
    "dialog": {
      "title": {
        "epic": "Select a {{Epic}} to promote {{Story}} to:",
        "theme": "Select a {{Theme}} to promote {{Epic}} to:"
      },
      "submit": {
        "epic": "Promote to {{Story}}",
        "theme": "Promote to {{Epic}}"
      },
      "success": {
        "epic": "{{Feedback}} successfuly promoted to {{Story}}",
        "theme": "{{Feedback}} successfuly promoted to {{Epic}}"
      }
    }
  },
  "integrations": {
    "noWorkspaces": "There are no workspaces connected to the feedback portal. Please connect a workspace in order to proceed",
    "csv": {
      "text1": "Import {{feedbacks}} from a CSV file to your feedback portal",
      "text2": "Imported {{feedback}} will be associated with the selected workspace",
      "text3": "Map required fields from your CSV to feedback portal",
      "text4": "* Please select {{feedback}} title column from CSV",
      "text5": "View {{feedback}} items",
      "single": "1 {{Feedback}} item",
      "plural": "{{count}} {{feedback}} items",
      "text6": "All {{feedback}} items must have a Title"
    },
    "slack": {
      "text1": "Are you sure you want to remove the connection to Slack @name? Once you remove it, messages from the Slack workspace will not be pushed to the feedback portal.\nExisting {{feedback}} items in the feedback portal will be kept.",
      "text2": "Your feedback portal is now connected to your Slack @name workspace. Start collecting {{feedback}} from everywhere in Slack."
    }
  },
  "reports": {
    "text1": "Your report is currently empty. Jumpstart your feedback portal by adding new {{feedback}}.",
    "text2": "Top Categories",
    "text3": "Total {{Feedbacks}}",
    "text4": "{{Feedback}} items recieved in the given time range",
    "text5": "{{Feedbacks}} Processed",
    "text6": "{{Feedback}} items recieved in the given time range, that their status was updated",
    "text7": "{{Feedbacks}} Connected",
    "text8": "{{Feedback}} items recieved in the given time range, that were connected to {{Epics}} or {{Stories}}",
    "text9": "Top {{Companies}}"
  },
  "errors": {
    "wrongInvitationId": "Sorry, it looks like this invitation is no longer valid.",
    "actionNotExists": "Oops! Something went wrong.",
    "termsAndConditions": "Please accept our terms and conditions and privacy policy to continue signing up with your Google account.",
    "googleWrongInviteEmail": "The selected Google account does not match the one to which the invitation was sent to. Please try again and select a matching account.",
    "googleWrongEmail": "The selected Google account is not signed up to the portal. Please retry by selecting another account.",
    "alreadySignedUpWithGoogle": "Your email address is already signed up through a Google account, please sign in by clicking on Sign in with Google",
    "alreadySignedUpWithSSO": "Your email address is already signed up through SSO, please sign in by clicking on Sign in with SSO",
    "userDeactivated": "{{email}} has been deactivated for this account. Please contact an account admin to reactivate that user.",
    "accessDeactivated": "Your access to the platform has been turned off. To restore it, contact an administrator at your organisation.",
    "sf_credentials_error": "We couldn’t connect to Salesforce due to an authorization issue. Please check your credentials (URL, key, and secret), or try reauthorizing your connection.",
    "sf_auth_token_error": "We couldn’t connect to Salesforce due to an unexpected authorization issue. Please check your credentials (URL, key, and secret), or try reauthorizing your connection.",
    "sf_get_fields_error": "We couldn’t retrieve field data from Salesforce. Please try again, or contact support if the issue continues.",
    "sf_mapping_error": "We couldn’t map your Salesforce data. Please ensure that the relevant fields exist in your Salesforce Account and that the mappings between Salesforce and Craft.io are correct.",
    "sf_get_accounts_error": "We couldn’t retrieve your account data from Salesforce. Please try again, or contact support if the issue continues.",
    "sf_soql_error": "We couldn’t validate your SOQL query. Please make sure the query is valid and properly formatted.",
    "sf_general_error": "Something went wrong. Please try again, or contact support if the issue continues."
  }
}
